module.exports = __webpack_public_path__ + "img/mini-landscape.330cde8.png";